import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HomeService } from 'src/app/services/home/home.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { StoresService } from 'src/app/services/stores/stores.service';
import { ModalComponent } from '../modal/modal/modal.component';

@Component({
	selector: 'app-pop-up-information',
	templateUrl: './pop-up-information.component.html',
	styles: [],
})
export class PopUpInformationComponent implements OnInit, OnDestroy {
	@ViewChild('modalComponent') modal: ModalComponent<PopUpInformationComponent> | undefined;

	@ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;


	type: string = '';
	private subscriptions: Array<Subscription> = [];
	terms: string = '';
	privacy: string = '';
	about: string = '';

	returnPolicy: string = '';
	shippingPolicy: string = '';
	subscriptionPolicy: string = '';

	store: boolean = true;
	constructor(private modalService: ModalService<any>, private stores: StoresService, private sanitizer: DomSanitizer, private router: Router, private homeService: HomeService) {
		this.router.url === '/' ? (this.store = false) : (this.store = true);
		this.listenType();
		this.router.url !== '/' && this.getConfigStore();
	}

	ngOnInit(): void {
		!this.store && this.getConfig();
	}

	getConfig() {
		this.subscriptions.push();
		this.homeService.getConfGeneralObs$().subscribe((config) => {
			config.map(({ name, value }) => {
				name === 'terms-gen' && (this.terms = value);
				name === 'return-policy' && (this.returnPolicy = value);
				name === 'shipping-policy' && (this.shippingPolicy = value);
				name === 'subscription-policy' && (this.subscriptionPolicy = value);
			});
		});
	}

	
	

	listenType() {
		this.subscriptions.push(
			this.modalService.getType().subscribe((value) => {
				this.type = value;
				!this.store && this.getConfig();
				this.router.url !== '/' && this.getConfigStore();
			})
		);
	}

	getConfigStore() {
		this.stores.getAllConfig().subscribe((config: any[]) => {
			config.map(({ name, value }) => {
				name === 'terms-and-conditions' && (this.terms = value);
				name === 'privacy-policies' && (this.privacy = value);
				name === 'about' && (this.about = value);
				name === 'return-policy' && (this.returnPolicy = value);
				name === 'shipping-policy' && (this.shippingPolicy = value);
				name === 'subscription-policy' && (this.subscriptionPolicy = value);

			});
		});
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
	}



	processHTML(html: any) {
		// Decodifica entidades HTML (&lt; -> <, &gt; -> >, etc.)
		const textarea = document.createElement("textarea");
		textarea.innerHTML = html;
		let decodedHtml = textarea.value;
	
		// Corrige etiquetas mal cerradas (<button> dentro de <strong>)
		decodedHtml = decodedHtml.replace(/<\/span><strong([^>]*)>/g, '<strong$1></span>');
	
		// Reemplaza <button> por un <a> real
		decodedHtml = decodedHtml.replace(
			/<button>([^<]+)<\/button>/g,
			`<button>$1</button>`
		);
	
		// Retorna el HTML saneado
		return this.sanitizer.bypassSecurityTrustHtml(decodedHtml);
	}

	async handleButtonClick(event: Event): Promise<void> {

		const target = event.target as HTMLElement;
		if (!target ) {
			return;
		}
		const type = target.textContent?.trim().toLowerCase().replace(/\s+/g, "-");
		if (!type) return;
		let typeFinal = type
		type === 'terms-and-conditions' && (typeFinal = 'terms');
		type === 'privacy-policy' && (typeFinal = 'politics');
		type === 'return-policy' && (typeFinal = 'returs-politics');
		type === 'shipping-policy' && (typeFinal = 'shipping-policy');


		this.modalService.setType(typeFinal)
		
		// Espera a que el DOM se actualice y luego hace scroll al inicio
		setTimeout(() => {
			if (this.scrollContainer?.nativeElement) {
				this.scrollContainer.nativeElement.scrollTop = 0;
			}
		}, 100);
	}

	async close(): Promise<void> {
		await this.modal?.close();
	}

	async openOtherModal(type:string): Promise<void> {
		this.modalService.setType(type)
		const {PopUpInformationComponent} = await import('../../shared/pop-up-information/pop-up-information.component');
		await this.modalService.open(PopUpInformationComponent);
		this.modalService.nameComponent.next('PopUpInformationComponent')
	}


}
